import XInfo1 from './xInfo1.vue'
export default XInfo1
